export const categories = [
  {
    slug: "baojing-anli",
    name: "爆奖案例",
    description: "真实玩家麻将爆奖瞬间，中17万大奖全记录",
    icon: "ri-trophy-line",
  },
  {
    slug: "majiang-jiqiao",
    name: "麻将技巧",
    description: "高手进阶技巧，提升麻将竞技水平",
    icon: "ri-lightbulb-line",
  },
  {
    slug: "paixing-fenxi",
    name: "牌型分析",
    description: "深度解析各类麻将牌型组合与胡牌策略",
    icon: "ri-bar-chart-box-line",
  },
  {
    slug: "xinshou-rumen",
    name: "新手入门",
    description: "麻将基础规则与入门指南，零基础也能学会",
    icon: "ri-user-star-line",
  },
  {
    slug: "saishi-zixun",
    name: "赛事资讯",
    description: "最新麻将竞技赛事动态与行业新闻",
    icon: "ri-newspaper-line",
  },
];

export const articles = [
  {
    slug: "majiang-hule-zhong-17wan",
    title: "麻将糊了中17万！真实爆奖案例全记录",
    category: "baojing-anli",
    excerpt: "一位资深玩家在线上麻将平台凭借一副绝妙牌型成功糊牌，一举斩获17万元大奖。本文将深度还原这场精彩对决的每一个细节。",
    content: `<p>在麻将竞技的世界里，每一次糊牌都可能带来惊喜，但能一举斩获17万元大奖的经历，却是极为罕见的。近日，一位来自广东的资深麻将玩家张先生（化名），在某知名线上麻将平台实现了这一令人瞩目的成就。</p>

<h2>爆奖瞬间回放</h2>

<p>据张先生回忆，当天晚上他像往常一样登录平台进行游戏。在进入高级房间后，他选择了一场高倍率对局。开局后，张先生的手牌并不算特别出色，但他凭借着多年的经验，稳扎稳打，逐步调整牌型。</p>

<p>关键的转折点出现在对局的第七轮。当时张先生已经听牌，手中握有一副清一色的雏形。在摸到一张关键牌后，他成功组成了<strong>清一色+碰碰胡+杠上开花</strong>的超级组合牌型，直接触发平台的高倍奖励机制。</p>

<p>"当时我整个人都愣住了，"张先生激动地表示，"系统提示我中了大奖，我反复看了好几遍才敢相信。"平台方面迅速确认了这一结果，17万元的奖金在24小时内就到达了张先生的账户。</p>

<h2>牌型深度解析</h2>

<p>这次爆奖的核心牌型组合堪称经典。我们请来了麻将竞技专家李老师进行专业分析：</p>

<h3>清一色（基础番数：24番）</h3>
<p>清一色要求玩家手中的所有牌均为同一花色，包括万子、筒子或条子中的一种。张先生本次糊牌为万子清一色，整副牌全由万子组成，整齐划一。</p>

<h3>碰碰胡（基础番数：6番）</h3>
<p>碰碰胡要求玩家手中的四组面子全部为刻子（三张相同）或杠子（四张相同），加上一对将牌。这种牌型对牌面要求极高，通常需要前期有良好的碰牌基础。</p>

<h3>杠上开花（基础番数：8番）</h3>
<p>杠上开花是指玩家在杠牌后，从牌墙末尾补牌时正好自摸糊牌。这种运气成分与技巧并存的牌型，往往能带来意想不到的惊喜。</p>

<p>李老师指出："这三者结合，番数相乘叠加，再配合平台的高倍场设定，最终成就了17万的高额奖金。"</p>

<h2>高倍奖励机制揭秘</h2>

<p>线上麻将平台普遍设有高倍奖励机制，主要包括以下几个方面：</p>

<ul>
<li><strong>基础场倍率：</strong>不同房间设有不同的基础倍率，高级房间的倍率通常是普通房间的5-10倍。</li>
<li><strong>牌型加成：</strong>特殊牌型组合会触发额外的倍数加成，番数越高，加成越大。</li>
<li><strong>连胜奖励：</strong>连续获胜可获得额外的倍率叠加。</li>
<li><strong>活动加成：</strong>平台定期推出的活动期间，特定牌型可获得额外奖励。</li>
</ul>

<h2>如何在合法平台上体验麻将竞技</h2>

<p>选择合法合规的线上麻将平台是享受竞技乐趣的前提。建议玩家注意以下几点：</p>

<ol>
<li>选择持有正规运营资质的平台</li>
<li>注意平台的游戏规则是否公开透明</li>
<li>合理控制游戏时间和投入</li>
<li>将麻将视为休闲竞技而非赌博工具</li>
<li>享受技巧与策略带来的成就感</li>
</ol>

<h2>专家技巧分享</h2>

<p>想要在麻将竞技中获得更好的成绩，除了运气，技巧同样重要。以下是几位麻将高手分享的实战经验：</p>

<ol>
<li><strong>记牌习惯：</strong>养成随时记牌的习惯，了解场上已经出过的牌，判断剩余牌墙中可能存在的牌。</li>
<li><strong>听牌策略：</strong>不要急于听牌，有时多等一轮反而能组成更高番数的牌型。</li>
<li><strong>观察对手：</strong>注意对手的出牌习惯和舍牌节奏，从中推测对方手牌情况。</li>
<li><strong>心理素质：</strong>保持良好的心态，不因一手好牌而冒进，也不因一手差牌而放弃。</li>
</ol>

<p>麻将作为中国传统文化的瑰宝，承载着丰富的智力竞技内涵。在合法合规的前提下，享受麻将带来的乐趣，提升自己的竞技水平，才是这项运动的真正魅力所在。</p>`,
    author: "麻将竞技编辑部",
    date: "2026-08-05",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20mahjong%20tiles%20on%20a%20rich%20dark%20wooden%20table%20with%20warm%20ambient%20lighting%2C%20red%20and%20gold%20aesthetic%2C%20elegant%20composition%2C%20clean%20background%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field&width=1200&height=630&seq=mahjong-article-01&orientation=landscape",
    tags: ["麻将爆奖", "麻将中大奖", "麻将高倍奖励", "线上麻将"],
    featured: true,
  },
  {
    slug: "qingyise-pengpenghu-gaoji-jiqiao",
    title: "清一色+碰碰胡组合牌型高级技巧详解",
    category: "paixing-fenxi",
    excerpt: "清一色与碰碰胡的组合是麻将中番数最高的牌型之一。本文将从手牌管理、听牌选择到舍牌策略，全方位拆解这一高级牌型的构建技巧。",
    content: `<p>在麻将的所有牌型组合中，清一色+碰碰胡的组合被认为是难度最高、回报最大的牌型之一。本文将深入探讨这一牌型的构建策略与实战技巧。</p>

<h2>清一色碰碰胡的基础认知</h2>

<p>清一色碰碰胡，顾名思义，是清一色和碰碰胡两种牌型的叠加。这意味着玩家的整副牌不仅要全部为同一花色，而且所有面子都必须是对对型（刻子或杠子），不能有任何顺子。</p>

<p>这种牌型的难度在于：单一花色的牌总共只有36张（以万子为例，从一万到九万各4张），要从中选出14张组成碰碰胡结构，选择范围极为有限。</p>

<h2>实战构建策略</h2>

<h3>第一阶段：花色选择</h3>
<p>开局后，快速评估三种花色的牌数分布。选择手牌中数量最多的花色作为清一色的目标花色。一般来说，如果某一花色在手牌中占到7张以上，就可以考虑向清一色方向发展。</p>

<h3>第二阶段：对子积累</h3>
<p>确定了花色方向后，开始有意识地积累该花色中的对子。碰碰胡需要4组刻子（或杠子）+1对将牌，因此至少需要在该花色中形成5对以上的牌。</p>

<h3>第三阶段：听牌策略</h3>
<p>清一色碰碰胡的听牌选择尤为关键。由于可选牌范围小，建议优先选择中间张数（如四万、五万、六万）作为听牌目标，因为这些牌在牌墙中的剩余概率通常更高。</p>

<h2>常见误区</h2>
<ul>
<li><strong>过早暴露意图：</strong>频繁碰牌会让对手察觉你的清一色意图，从而进行针对性防守。</li>
<li><strong>忽视安全牌：</strong>一心追求高番牌型而忽视防守，容易被对手抢先糊牌。</li>
<li><strong>死守一种花色：</strong>当局势明显不利时，应及时调整策略，不必一味追求清一色。</li>
</ul>`,
    author: "李老师",
    date: "2026-08-03",
    image: "https://readdy.ai/api/search-image?query=Closeup%20of%20mahjong%20tiles%20arranged%20in%20a%20pure%20one%20suit%20hand%20on%20a%20dark%20wooden%20surface%2C%20warm%20golden%20light%2C%20elegant%20Chinese%20aesthetic%2C%20professional%20product%20photography&width=1200&height=630&seq=mahjong-article-02&orientation=landscape",
    tags: ["清一色", "碰碰胡", "牌型技巧", "麻将高倍奖励"],
    featured: true,
  },
  {
    slug: "xinshou-majiang-ru-men-zhinan",
    title: "零基础麻将入门：从规则到实战完全指南",
    category: "xinshou-rumen",
    excerpt: "从未接触过麻将？不用担心！本指南将从麻将牌的种类、基本规则、糊牌条件到实战技巧，带你一步步走进麻将的精彩世界。",
    content: `<p>麻将作为中国最受欢迎的桌面竞技游戏之一，有着数百年的悠久历史。对于从未接触过麻将的新手来说，这套复杂的规则可能看起来令人望而生畏。但实际上，掌握麻将的核心规则并不困难。</p>

<h2>一、认识麻将牌</h2>

<p>一副标准麻将共有144张牌，分为以下几类：</p>

<h3>数牌（108张）</h3>
<ul>
<li><strong>万子：</strong>一万至九万，各4张，共36张</li>
<li><strong>筒子：</strong>一筒至九筒，各4张，共36张</li>
<li><strong>条子：</strong>一条至九条，各4张，共36张</li>
</ul>

<h3>字牌（28张）</h3>
<ul>
<li><strong>风牌：</strong>东、南、西、北，各4张，共16张</li>
<li><strong>箭牌：</strong>中、发、白，各4张，共12张</li>
</ul>

<h3>花牌（8张）</h3>
<ul>
<li>春、夏、秋、冬、梅、兰、竹、菊，各1张</li>
</ul>

<h2>二、基本规则</h2>

<p>麻将通常由4人参与。每位玩家起始有13张手牌，庄家有14张。游戏按照逆时针方向进行，每轮玩家摸一张牌后打出一张牌。</p>

<h3>核心目标：组成合法牌型</h3>
<p>一副合法的糊牌牌型由4组面子（每组3张）和1对将牌（2张）组成，共14张牌。</p>

<h3>面子类型</h3>
<ul>
<li><strong>顺子：</strong>同花色连续的三张牌，如三万、四万、五万</li>
<li><strong>刻子：</strong>三张完全相同的牌，如三张八筒</li>
<li><strong>杠子：</strong>四张完全相同的牌（需要开杠）</li>
</ul>

<h2>三、基本术语</h2>
<ul>
<li><strong>摸牌：</strong>从牌墙上取一张牌</li>
<li><strong>出牌：</strong>打出一张手牌</li>
<li><strong>吃牌：</strong>用上家打出的牌组成顺子</li>
<li><strong>碰牌：</strong>用任意玩家打出的牌组成刻子</li>
<li><strong>杠牌：</strong>有四张相同的牌时可以开杠</li>
<li><strong>听牌：</strong>只差一张牌就能糊牌的状态</li>
<li><strong>自摸：</strong>自己摸到需要的牌完成糊牌</li>
<li><strong>点炮：</strong>其他玩家打出的牌正好是你需要的</li>
</ul>

<h2>四、新手常见错误</h2>
<ol>
<li>不记牌，盲目出牌</li>
<li>过早确定方向，不会灵活调整</li>
<li>忽视防守，只顾自己组牌</li>
<li>对番数没有概念，不了解牌型分值</li>
</ol>

<p>掌握了以上基础知识，你就已经准备好开始你的第一局麻将了。记住，熟能生巧，多多练习才能真正体会到麻将的魅力！</p>`,
    author: "新手指导员",
    date: "2026-08-01",
    image: "https://readdy.ai/api/search-image?query=Colorful%20mahjong%20tiles%20spread%20on%20a%20clean%20light%20wooden%20surface%20with%20instructional%20layout%2C%20bright%20natural%20lighting%2C%20beginner%20friendly%20aesthetic%2C%20educational%20photography&width=1200&height=630&seq=mahjong-article-03&orientation=landscape",
    tags: ["新手入门", "麻将规则", "麻将竞技娱乐"],
    featured: false,
  },
  {
    slug: "2026-quanguo-majiang-dasai",
    title: "2026年全国麻将竞技大赛报名开启，总奖金超百万",
    category: "saishi-zixun",
    excerpt: "2026年全国麻将竞技大赛正式启动报名，赛事总奖金突破百万元大关。本届大赛新增线上预选赛环节，让更多麻将爱好者有机会参与其中。",
    content: `<p>备受瞩目的2026年全国麻将竞技大赛于近日正式启动报名工作。本届大赛由中国麻将竞技协会主办，旨在推广麻将文化，提升国民麻将竞技水平。</p>

<h2>赛事亮点</h2>

<ul>
<li><strong>总奖金池：</strong>超过100万元人民币，创历届新高</li>
<li><strong>参赛规模：</strong>预计吸引超过5万名选手报名</li>
<li><strong>赛制创新：</strong>首次引入线上线下结合的混合赛制</li>
<li><strong>直播覆盖：</strong>决赛阶段将通过多个平台进行全程直播</li>
</ul>

<h2>赛程安排</h2>

<p>本届大赛分为三个阶段：</p>

<ol>
<li><strong>线上预选赛（8月15日-9月15日）：</strong>选手通过官方合作平台进行线上对局，系统根据胜率和番数自动排名。</li>
<li><strong>区域淘汰赛（10月1日-10月30日）：</strong>各地区前100名选手进入线下淘汰赛，在广州、北京、成都、上海四个赛区同步进行。</li>
<li><strong>全国总决赛（11月15日-11月20日）：</strong>64名晋级选手齐聚深圳，争夺最终冠军。</li>
</ol>

<h2>报名方式</h2>

<p>有意参赛的选手可通过官方小程序或合作平台进行报名，报名截止日期为8月10日。报名费用为每人50元，包含线上预选赛的全部对局费用。</p>

<p>麻将不仅是娱乐，更是一项需要智慧与策略的竞技运动。期待在赛场上看到更多精彩的对决！</p>`,
    author: "赛事记者",
    date: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=Grand%20mahjong%20tournament%20stage%20with%20professional%20players%20and%20large%20screens%2C%20excited%20crowd%2C%20red%20and%20gold%20decorations%2C%20competitive%20atmosphere%2C%20event%20photography&width=1200&height=630&seq=mahjong-article-04&orientation=landscape",
    tags: ["赛事资讯", "麻将竞技娱乐", "线上麻将"],
    featured: true,
  },
  {
    slug: "gangshangkaihua-baojiang-jiemi",
    title: "杠上开花爆奖机制解密：为什么它能翻倍",
    category: "baojing-anli",
    excerpt: "杠上开花是麻将中最令人兴奋的糊牌方式之一。本文揭秘杠上开花的爆奖机制，分析为什么这种牌型能获得如此高的倍数加成。",
    content: `<p>在众多麻将糊牌方式中，杠上开花无疑是最具戏剧性的一种。那种在杠牌后，从牌墙末尾摸到关键牌完成自摸的瞬间，堪称麻将竞技中最激动人心的时刻。</p>

<h2>什么是杠上开花</h2>

<p>杠上开花，是指玩家在杠牌（包括明杠、暗杠、加杠）后，从牌墙尾部补牌时，恰好自摸糊牌。这种糊牌方式因其"意外之喜"的属性，在各大麻将规则中都被赋予了较高的分值。</p>

<h2>杠上开花的番数计算</h2>

<p>在国标麻将中，杠上开花的基础番数为8番。这看似不多，但当它与其它牌型组合时，总番数会呈现几何级增长。</p>

<h3>常见组合示例</h3>
<ul>
<li>杠上开花 + 清一色（24番）= 32番</li>
<li>杠上开花 + 碰碰胡（6番）+ 清一色（24番）= 38番</li>
<li>杠上开花 + 七对（24番）= 32番</li>
</ul>

<h2>线上平台的爆奖机制</h2>

<p>线上麻将平台通常会在基础番数之上，叠加以下奖励：</p>

<ul>
<li><strong>稀有事件奖励：</strong>杠上开花属于小概率事件，平台会对这类"天选时刻"给予额外倍率。</li>
<li><strong>连续触发加成：</strong>如果玩家在同一局中多次杠上开花，奖励会呈指数级增长。</li>
<li><strong>时段加成：</strong>高峰时段或活动期间，特殊牌型的基础倍率会临时上调。</li>
</ul>

<h2>实战技巧</h2>

<p>虽然杠上开花主要靠运气，但通过以下策略可以增加出现概率：</p>

<ol>
<li>有杠就开，不犹豫</li>
<li>听牌后再开杠，增加杠上开花的可能性</li>
<li>选择牌墙末尾剩余牌多的时机开杠</li>
<li>在高倍场中，杠上开花的收益更加可观</li>
</ol>

<p>杠上开花的魅力在于它的不可预测性。正是这种"柳暗花明又一村"的惊喜感，让无数麻将爱好者乐此不疲。</p>`,
    author: "麻将竞技编辑部",
    date: "2026-07-25",
    image: "https://readdy.ai/api/search-image?query=A%20single%20mahjong%20tile%20being%20drawn%20from%20the%20wall%20in%20dramatic%20lighting%2C%20suspenseful%20moment%2C%20dark%20background%20with%20golden%20accents%2C%20cinematic%20photography&width=1200&height=630&seq=mahjong-article-05&orientation=landscape",
    tags: ["杠上开花", "麻将爆奖", "麻将高倍奖励"],
    featured: false,
  },
  {
    slug: "qidui-gaoji-wanfa",
    title: "七对牌型高级玩法：从入门到精通的完整路线",
    category: "paixing-fenxi",
    excerpt: "七对是麻将中一种特殊的牌型，不需要顺子和刻子，只需七对牌即可糊牌。本文深入分析七对的各种变体与高级技巧。",
    content: `<p>七对，又称"七小对"，是麻将中一种非常特殊的牌型。与常规牌型不同，七对不需要任何顺子或刻子，只需要七组完全相同的对子即可糊牌。</p>

<h2>七对的基础条件</h2>

<p>七对牌型要求：</p>
<ul>
<li>手中有7对完全相同的牌（共14张）</li>
<li>不能有任何刻子或顺子</li>
<li>不能有杠牌</li>
</ul>

<h2>七对的番数</h2>

<p>在国标麻将中，基础七对为24番。如果七对中的牌全部为同一花色（清七对），则番数更高。</p>

<h2>七对的变体</h2>

<h3>龙七对</h3>
<p>七对中有四张相同的牌算作两对，称为龙七对，番数更高。</p>

<h3>豪华七对</h3>
<p>七对中所有对子都是字牌或幺九牌，番数极高。</p>

<h2>实战策略</h2>
<ol>
<li>前期尽量保留各种牌，不做取舍</li>
<li>优先保留已经成对的牌</li>
<li>观察场上已出的牌，判断剩余概率</li>
<li>适当保留边张和孤张，增加凑对机会</li>
</ol>`,
    author: "李老师",
    date: "2026-07-22",
    image: "https://readdy.ai/api/search-image?query=Seven%20pairs%20of%20mahjong%20tiles%20neatly%20arranged%20in%20a%20row%20on%20a%20dark%20wooden%20table%2C%20minimalist%20composition%2C%20warm%20lighting%20from%20above%2C%20clean%20elegant%20aesthetic&width=1200&height=630&seq=mahjong-article-06&orientation=landscape",
    tags: ["七对", "牌型技巧", "麻将竞技娱乐"],
    featured: false,
  },
  {
    slug: "majiang-xinli-zhan",
    title: "麻将中的心理战：读懂对手的七个信号",
    category: "majiang-jiqiao",
    excerpt: "麻将不仅是牌技的较量，更是心理的博弈。学会读懂对手的微表情、出牌节奏和舍牌习惯，让你在牌桌上占尽先机。",
    content: `<p>在高水平的麻将对局中，牌技的差距往往微乎其微，真正决定胜负的，是心理层面的博弈。本文将为你揭示麻将心理战的七大关键信号。</p>

<h2>信号一：出牌速度的变化</h2>
<p>当对手的出牌速度突然加快或减慢，往往意味着他的手牌状态发生了变化。突然加快通常表示手牌进展顺利，可能已经听牌；突然减慢则可能表示遇到了选择困难。</p>

<h2>信号二：舍牌顺序的规律</h2>
<p>大多数玩家都有固定的舍牌顺序习惯。当这个规律被打破时——比如突然打出一张"好牌"——往往说明对手的手牌构成发生了重大调整。</p>

<h2>信号三：碰牌的犹豫</h2>
<p>当对手在碰牌时出现明显犹豫，很可能是这张牌与他正在构建的牌型存在冲突，或者碰牌会暴露他的真实意图。</p>

<h2>信号四：摸牌后的表情</h2>
<p>摸到好牌时，即便是最有经验的玩家也很难完全掩饰那一瞬间的喜悦。留意对手摸牌后的微表情变化，往往能获得重要信息。</p>

<h2>信号五：听牌后的行为变化</h2>
<p>听牌后的玩家通常会出现以下行为变化：身体前倾、呼吸节奏改变、出牌更加果断（或更加谨慎）、频繁查看已打出的牌。</p>

<h2>信号六：防御心态的暴露</h2>
<p>当对手开始大量保留安全牌、频繁打出与之前风格不符的牌时，说明他进入了防守状态，很可能是因为你的牌型让他感到了威胁。</p>

<h2>信号七：言语和肢体语言</h2>
<p>"这把牌太差了"——这种话往往是烟雾弹。真正牌差的人通常保持沉默，而声称自己牌差的人，很可能已经悄悄听牌了。</p>

<h2>如何训练心理观察力</h2>
<ol>
<li>每局结束后回顾对手的关键行为</li>
<li>养成观察对手舍牌规律的习惯</li>
<li>在安全的前提下，故意测试对手的反应</li>
<li>控制好自己的表情和节奏，不给对手可乘之机</li>
</ol>`,
    author: "心理战术分析师",
    date: "2026-07-20",
    image: "https://readdy.ai/api/search-image?query=Two%20players%20facing%20each%20other%20over%20a%20mahjong%20table%20with%20intense%20eye%20contact%2C%20dramatic%20lighting%2C%20psychological%20tension%2C%20cinematic%20composition%2C%20dark%20moody%20background&width=1200&height=630&seq=mahjong-article-07&orientation=landscape",
    tags: ["麻将技巧", "心理战", "麻将竞技娱乐"],
    featured: true,
  },
  {
    slug: "xianshang-majiang-pingtai-xuanze",
    title: "如何选择靠谱的线上麻将平台？五大评估标准",
    category: "xinshou-rumen",
    excerpt: "市场上线上麻将平台鱼龙混杂，如何选择一个安全、公平、有趣的平台？本文为你提供五大核心评估标准。",
    content: `<p>随着线上麻将的普及，市场上出现了大量的线上麻将平台。对于新手玩家来说，如何从中筛选出靠谱的平台，成为了一个重要的课题。</p>

<h2>标准一：运营资质</h2>
<p>合法合规是选择平台的第一标准。查看平台是否具备相关运营资质，是否有明确的公司信息和联系方式。</p>

<h2>标准二：游戏公平性</h2>
<p>优质平台应采用经过认证的随机发牌算法，确保每局游戏的公平性。可以关注平台是否有第三方机构的技术认证。</p>

<h2>标准三：用户评价与口碑</h2>
<p>在选择平台前，建议查阅多个渠道的用户评价。注意区分真实评价和水军刷评，重点关注关于提现速度、客服响应等实际体验的反馈。</p>

<h2>标准四：功能体验</h2>
<p>好的平台应具备流畅的操作体验、清晰的界面设计、完善的新手教程和合理的匹配机制。</p>

<h2>标准五：安全保障</h2>
<p>关注平台的账户安全措施、数据加密水平和隐私保护政策。靠谱的平台会投入充足的资源保障用户信息和资金安全。</p>`,
    author: "新手指导员",
    date: "2026-07-18",
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20mahjong%20game%20interface%20with%20clean%20design%2C%20placed%20on%20a%20wooden%20desk%20with%20warm%20lighting%2C%20professional%20tech%20product%20photography&width=1200&height=630&seq=mahjong-article-08&orientation=landscape",
    tags: ["线上麻将", "新手入门", "麻将竞技娱乐"],
    featured: false,
  },
  {
    slug: "baojiang-wanjia-caifang",
    title: "独家访谈：三个月中三次大奖的麻将高手心得",
    category: "baojing-anli",
    excerpt: "一位在三个月内连续三次斩获高额奖金的麻将玩家，分享了他在牌型选择、风险管理和心态调整方面的独到见解。",
    content: `<p>王先生（化名）是圈内小有名气的麻将玩家，在过去的三个月中，他连续三次在不同的线上平台斩获了高额奖金。我们对他进行了独家专访。</p>

<h2>关于牌型选择</h2>
<p>"很多人一上来就想做大牌，这是最大的误区。"王先生说，"我的经验是，前五轮先观察，看看手牌的发展方向。如果明显有清一色的趋势，那就大胆追；如果发现不行，立刻转向小牌型，先确保不输。"</p>

<h2>关于风险管理</h2>
<p>"风险控制比追求高分更重要。我给自己定了三条铁律：不在状态不好时玩高倍场、不在一局中投入超过预算的20%、连续输三局就休息半小时。"</p>

<h2>关于心态调整</h2>
<p>"麻将最怕的就是上头。赢了想赢更多，输了想翻本，这种心态一定会出问题。我的做法是，每次玩之前设定一个明确的止盈点和止损点，到了就停。"</p>

<h2>给新手的建议</h2>
<ol>
<li>先从小倍率场开始积累经验</li>
<li>多看高手对局的复盘视频</li>
<li>每次输牌后都要总结原因</li>
<li>保持规律的作息，不在疲劳时打牌</li>
</ol>`,
    author: "麻将竞技编辑部",
    date: "2026-07-15",
    image: "https://readdy.ai/api/search-image?query=A%20successful%20mahjong%20player%20smiling%20confidently%20at%20a%20mahjong%20table%20with%20tiles%20and%20chips%2C%20warm%20ambient%20lighting%2C%20portrait%20style%20photography%2C%20professional%20yet%20approachable&width=1200&height=630&seq=mahjong-article-09&orientation=landscape",
    tags: ["麻将爆奖", "麻将中大奖", "麻将技巧"],
    featured: false,
  },
  {
    slug: "guobiao-majiang-guize-xiangjie",
    title: "国标麻将规则详解：81种番种全解析",
    category: "xinshou-rumen",
    excerpt: "国标麻将作为最具权威性的麻将竞技规则，共有81种官方认定的番种。本文为你系统梳理这81种番种的分级与识别方法。",
    content: `<p>国标麻将是国家体育总局于1998年颁布的竞技麻将规则，共有81种官方认定的番种。这81种番种按照分值分为12个等级，从1番到88番不等。</p>

<h2>88番牌型（最高等级）</h2>
<ul>
<li><strong>大四喜：</strong>由4副风刻（杠）组成的和牌</li>
<li><strong>大三元：</strong>和牌中有中发白3副刻子</li>
<li><strong>绿一色：</strong>由23468条及发字中的任何牌组成的顺子、刻子、将的和牌</li>
<li><strong>九莲宝灯：</strong>由一种花色序数牌子按1112345678999组成的特定牌型</li>
<li><strong>四杠：</strong>4个杠</li>
<li><strong>连七对：</strong>由一种花色序数牌组成序数相连的7个对子的和牌</li>
<li><strong>十三幺：</strong>由3种序数牌的一、九牌，7种字牌及其中一对作将组成的和牌</li>
</ul>

<h2>64番牌型</h2>
<ul>
<li>小四喜、小三元、字一色、四暗刻、一色双龙会</li>
</ul>

<h2>48番牌型</h2>
<ul>
<li>一色四同顺、一色四节高</li>
</ul>

<h2>32番牌型</h2>
<ul>
<li>一色四步高、三杠、混幺九</li>
</ul>

<h2>24番牌型</h2>
<ul>
<li>七对、七星不靠、全双刻、清一色、一色三同顺、一色三节高、全大、全中、全小</li>
</ul>

<p>了解番种体系是提升麻将竞技水平的基础。建议新手从常见的24番以下牌型开始熟悉，逐步向高番牌型挑战。</p>`,
    author: "李老师",
    date: "2026-07-12",
    image: "https://readdy.ai/api/search-image?query=Professional%20mahjong%20rulebook%20and%20tiles%20arranged%20in%20various%20winning%20patterns%20on%20a%20wooden%20table%2C%20educational%20setting%2C%20bright%20clean%20lighting%2C%20organized%20composition&width=1200&height=630&seq=mahjong-article-10&orientation=landscape",
    tags: ["国标麻将", "新手入门", "麻将规则"],
    featured: false,
  },
];

export const faqs = [
  {
    question: "麻将糊了中17万是真的吗？",
    answer: "是的，这是真实发生的案例。一位玩家在合法线上麻将平台凭借清一色+碰碰胡+杠上开花的超级组合牌型，成功斩获17万元高额奖金。平台方面已确认该结果，奖金在24小时内到账。",
  },
  {
    question: "线上麻将平台安全吗？如何选择靠谱平台？",
    answer: "选择持有正规运营资质、有良好用户口碑的平台非常重要。建议关注平台的运营资质、用户评价、游戏公平性认证、功能体验和安全保障措施，综合评估后做出选择。",
  },
  {
    question: "麻将爆奖需要什么条件？",
    answer: "麻将爆奖通常需要满足以下条件：在高倍率房间进行游戏、组成高番数的特殊牌型组合、触发平台的稀有事件奖励机制。运气和技巧都是不可或缺的因素。",
  },
  {
    question: "新手如何快速提升麻将技巧？",
    answer: "建议从以下几个方面入手：先掌握基本规则和常见牌型、多看高手对局复盘、从小倍率场开始积累经验、养成记牌和分析对手的习惯、保持良好的心态。",
  },
  {
    question: "什么是麻将中的高倍奖励机制？",
    answer: "高倍奖励机制是线上麻将平台为增加游戏趣味性设置的特殊规则，包括基础场倍率、牌型加成、连胜奖励和活动加成等多个维度。高番数牌型组合能触发更高的倍数加成。",
  },
  {
    question: "麻将竞技和赌博有什么区别？",
    answer: "麻将竞技强调的是智力比拼和策略较量，是一种健康的娱乐方式。合法平台以休闲竞技为核心，不涉及赌博活动。我们倡导将麻将视为传统文化和智力运动，在合法合规的前提下享受其中的乐趣。",
  },
];

export const testimonials = [
  {
    name: "张先生",
    role: "资深麻将玩家",
    content: "在这个平台上玩了两年多了，界面流畅，匹配公平，最重要的是客服响应非常及时。之前中了小奖，提现也是秒到账。",
    rating: 5,
  },
  {
    name: "李女士",
    role: "麻将爱好者",
    content: "作为一个麻将新手，这里的新手教程和牌型分析文章对我帮助很大。现在我已经能独立完成清一色了！",
    rating: 5,
  },
  {
    name: "王先生",
    role: "竞技麻将选手",
    content: "参加过几次平台组织的线上比赛，组织得非常专业。希望以后能有更多这样的赛事机会。",
    rating: 4,
  },
];

export const aboutInfo = {
  brandName: "麻将竞技资讯",
  intro: "麻将竞技资讯平台致力于传播麻将文化，分享真实的麻将竞技经验与技巧。我们汇聚了众多麻将高手和资深玩家，为麻将爱好者提供最新、最全面的麻将资讯、牌型分析和实战技巧。",
  mission: "让每一位麻将爱好者都能在合法、健康的环境中享受麻将竞技的乐趣，传承中华麻将文化的精髓。",
  values: ["专业权威", "真实可信", "健康竞技", "文化传承"],
  contact: {
    email: "contact@mahjong-news.example.com",
    wechat: "MahjongNews_Official",
    address: "广东省广州市天河区体育西路123号中侨大厦15楼",
  },
};